/**
 * The clock every modeled layer reads. Normally the wall clock — but a
 * `?simNow=2026-09-09T08:30` query (Bangkok local, no zone) pins the start
 * instant and lets it run forward in real time, so the POP Bus fleet and
 * the occupancy / parking / traffic models can be shown at any hour of any
 * day. Demo and verification affordance only: nothing server-side reads it,
 * and the SIM badges stay on regardless.
 */
const BKK_OFFSET_MS = 7 * 60 * 60 * 1000;

function parseSimNow(search: string): number | null {
  const raw = new URLSearchParams(search).get("simNow");
  if (!raw) return null;
  // Treat a zone-less stamp as Bangkok time; anything with an explicit zone is honoured as-is.
  const hasZone = /[zZ]|[+-]\d\d:?\d\d$/.test(raw);
  const t = Date.parse(hasZone ? raw : `${raw}+07:00`);
  return Number.isFinite(t) ? t : null;
}

const pinned = typeof window === "undefined" ? null : parseSimNow(window.location.search);
const loadedAt = Date.now();

/** True when the page is running on a pinned demo clock. */
export const isSimClockPinned = pinned != null;

/** Current instant for all modeled layers. */
export function simNow(): Date {
  return pinned == null ? new Date() : new Date(pinned + (Date.now() - loadedAt));
}

/** Exposed for tests. */
export const _parseSimNow = parseSimNow;
export const _BKK_OFFSET_MS = BKK_OFFSET_MS;
